import axios from '../../../axiosInstance';

export const getProductsByStayId = (id: string, auth: any) => {
  return axios.get(`/locations/tag/${id}/inventory`);
};
